export enum CredentialsStatus {
  Active = 'ACTIVE',
  Disabled = 'DISABLED'
}
